<template>
  <div class="app-container" style="position: relative; height: 600px">
    <div
      id="container"
      v-loading="loading"
      element-loading-text="正在为您加载......"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255, 0.8)"
    ></div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        default: () => []
      },
      centerPoint: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        loading: false,
        windowHeight: document.documentElement.clientHeight, // 实时屏幕高度
        map: null,
        marker: null,
        infoWindow: null,
        orderList: [],
        query: {},
        minutesList: [],
        poolingOrderList: [],
        orderNum: 0,
        stationData: null,
        log: 102.71,
        lat: 25.01,
        showMapDetail: false,
        poolingOrder: [], // 已搓单列表
        driverList: []
      }
    },

    created() {},
    mounted() {
      this.initAMap(this.data)
    },
    methods: {
      // 初始化地图
      initAMap(data) {
        // 基本地图加载
        this.map = new AMap.Map('container', {
          resizeEnable: true,
          // center: [data.point.lon, data.point.lat], // 地图中心点
          // center: [data.nearVehicleVos[0].point.lon, data.nearVehicleVos[0].point.lat], // 地图中心点
          center: this.centerPoint, // 地图中心点
          zoom: 14, // 地图显示的缩放级别
          offset: new AMap.Pixel(0, -30),
          viewMode: '3D', // 是否为3D地图模式
          expandZoomRange: true, // 支持可以扩展最大缩放级别
          // pitch: 30, //俯仰角度 2D地图下无效,自V1.4.0开始支持
          mapStyle: 'amap://styles/normal' // 地图样式，彩色
        })

        this.labelsLayer(data)
      },

      // 海量点标注
      labelsLayer(data) {
        var that = this

        // position = [
        //   {
        //     name: '自提点3',
        //     position: [102.718437, 25.012356],
        //     zooms: [10, 20],
        //     zIndex: 8,
        //     icon,
        //     text: {
        //       content: '',
        //       direction: 'right',
        //       offset: [0, -5],
        //       style: {
        //         fontSize: 14,
        //         fontWeight: 'normal',
        //         fillColor: '#fff',
        //         fold: true,
        //         padding: '2, 5'
        //       }
        //     }
        //   }
        // ]

        that.map.on('complete', () => {
          /* 1.创建 LabelMarker，
					2.创建 LabelsLayer，将已创建的 LabelMarker 添加到 LabelsLayer 上
					3. 将 LabelsLayer 添加到地图实例 */
          var labelsLayer = new AMap.LabelsLayer({
            zooms: [1, 20],
            zIndex: 1000,
            // 该层内标注是否避让
            collision: true,
            // 设置 allowCollision：true，可以让标注避让用户的标注
            allowCollision: true
          })

          // 将 LabelsLayer 添加到地图实例
          that.map.add(labelsLayer)
          that.infoWindow = new AMap.InfoWindow({
            offset: new AMap.Pixel(0, -4)
          }) // 信息窗口

          const markers = []
          console.log(1111, data)
          var labelMarker
          for (var i = 0; i < data.length; i++) {
            var curData = data[i]
            labelMarker = new AMap.LabelMarker(curData)
            markers.push(labelMarker)
          }
          labelsLayer.add(markers)
          that.loading = false
        })
      },

      uniqueByPosition(arr) {
        const seen = new Set()
        return arr.filter((item) => {
          // 将position数组转换为字符串作为唯一标识
          const positionKey = item.position.join(',')
          if (!seen.has(positionKey)) {
            seen.add(positionKey)
            return true
          }
          return false
        })
      },

      destroyed() {
        // 销毁地图，并清空地图容器.该方法执行后，地图对象被注销，内存释放，地图容器被清空。
        this.map.destroy()
      }
    }
  }
</script>

<style scoped lang="scss">
  #app-container {
    width: 100%;
    position: relative;
  }

  #container {
    width: 100%;
    height: 100%;
  }

  .search-contain {
    position: absolute;
    top: 0;
    z-index: 999;
    background-color: #fff;
    width: 100%;
    padding-top: 20px;
    padding-left: 20px;
  }
  ::v-deep .amap-marker-label {
    position: absolute;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0);
    white-space: nowrap;
    cursor: default;
    padding: 4px 15px;
    font-size: 12px;
    line-height: 14px;
    border: none;
  }
  ::v-deep .info {
    position: relative;
  }
  ::v-deep .image {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  ::v-deep .num {
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    color: #fff;
    font-size: 14px;
  }
  ::v-deep .text {
    background-color: #fff;
    padding: 4px 9px;
    box-sizing: border-box;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  }
</style>
